import type { JSX } from 'react';
import React from 'react';

import LeftPanelContentBeta from './LeftPanelContent.beta';

import * as styles from './LeftPanelContent.css';

function LeftPanelContent(): JSX.Element {
  return <div className={styles.root}>LeftPanelContent</div>;
}

LeftPanelContent.Beta = LeftPanelContentBeta;

export default LeftPanelContent;
